export interface NbWidth {
  code: string;
  description: string;
}

export const NB_WIDTH_TABLE_MALE: NbWidth[] = [
  { code: '2A', description: 'Очень узкая' },
  { code: 'B', description: 'Узкая' },
  { code: 'D', description: 'Стандартная' },
  { code: '2E', description: 'Широкая' },
  { code: '4E', description: 'Очень широкая' },
  { code: '6E', description: 'Самая широкая' },
];

export const NB_WIDTH_TABLE_FEMALE: NbWidth[] = [
  { code: '4A', description: 'Очень узкая' },
  { code: '2A', description: 'Узкая' },
  { code: 'B', description: 'Стандартная' },
  { code: 'D', description: 'Широкая' },
  { code: '2E', description: 'Очень широкая' },
  { code: '4E', description: 'Самая широкая' },
];
